import styled from 'styled-components';
import InputMask from 'react-input-mask';
import media from 'styled-media-query';

export const FormWrapper = styled.form`
	margin-bottom: 3rem;
    max-width: 500px;
	width: 100%;
`;

export const FormInline = styled.div`
    ${media.greaterThan('medium')`
        display: grid;
        grid-auto-flow: column;
        grid-gap: 1rem;
    `}
`;

export const InputGroup = styled.div`
	margin-bottom: 1.5rem;
	width: 100%;
`;

export const Label = styled.label`
	color: #5B5B5B;
    padding-bottom: 0.25rem;
`;

export const Input = styled.input`
	border: 1px solid #BDBDBD;
	border-radius: 0.5rem;
	display: block;
    font-size: 16px;
	padding: 0.75rem;
	width: 100%;

	&::placeholder {
		color: #BDBDBD;
	}

	&.hasError {
		border-color: tomato;
	}

	&.hasError + span {
		display: block;
	}
`;

export const MaskInput = styled(InputMask)`
	border: 1px solid #BDBDBD;
	border-radius: 0.5rem;
	display: block;
    font-size: 16px;
	padding: 0.75rem;
	width: 100%;

	&::placeholder {
		color: #BDBDBD;
	}

	&.hasError {
		border-color: tomato;
	}

	&.hasError + span {
		display: block;
	}
`;

export const InputFileWrapper = styled.div`
    border: 1px solid #BDBDBD;
	border-radius: 0.5rem;
	display: block;
	width: 100%;
`;

export const InputFileTrigger = styled.label`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
`;

export const InputFileIcon = styled.span`
    background: url('${process.env.PUBLIC_URL}/images/icons/upload.svg') no-repeat center;
    display: flex;
    justify-content: center;
    height: 1.45rem;
    width: 2rem;

    ${({ hasFile }) => hasFile && `background: url('${process.env.PUBLIC_URL}/images/icons/trash.svg') no-repeat center;`}
`;

export const InputFileName = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Select = styled.select`
    appearance: none;
    background: url('${process.env.PUBLIC_URL}/images/icons/arrow-down.svg') no-repeat 97% center;
	border: 1px solid #BDBDBD;
	border-radius: 0.5rem;
	display: block;
    font-size: 16px;
	padding: 0.75rem;
	width: 100%;

	&::placeholder {
		color: #BDBDBD;
	}

	&.hasError {
		border-color: tomato;
	}

	&.hasError + span {
		display: block;
	}
`;

export const TextArea = styled.textarea`
	border: 1px solid #BDBDBD;
	border-radius: 0.5rem;
	display: block;
    font-family: inherit;
    font-size: 16px;
    height: 100px;
	padding: 0.75rem;
    resize: none;
	width: 100%;

	&::placeholder {
		color: #BDBDBD;
	}

	&.hasError {
		border-color: tomato;
	}

	&.hasError + span {
		display: block;
	}
`;

export const MessageError = styled.span`
	display: none;
	color: tomato;
	font-size: 0.75rem;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 3rem;
`;

export const Button = styled.button`
    background-color: var(--main-color);
    border: 1px solid var(--main-color);
    border-radius: 0.5rem;
    color: #FFF;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    transition: 0.25s ease;
    width: 100%;

    &:hover {
        background-color: var(--main-color);
        color: #FFF;
    }

    &:disabled {
        background-color: #E0E0E0;
        border-color: #E0E0E0;
		cursor: not-allowed;
    }

    ${media.greaterThan('medium')`
        max-width: 250px;
    `}
`;
